<template>
	<div>
		<!-- 个人中心 - 发票管理 - 列表 -->
		<div class="user-info6 w-100 style2">
			<a @click="pageJump('/invoiceManage')">申请发票</a>
			<a class="active">发票列表</a>
			<a @click="pageJump('/invoiceManageSet')">发票设置</a>
		</div>
		<form action="" class="w-100 layui-form" method="post">
			<div class="user-info3 w-100 between-center">
				<input type="text" class="layui-input" name="" id="test" value="" placeholder="起始时间 - 结束时间" />
				<select name="">
					<option value="">开票状态</option>
				</select>
				<div class="btns">
					<input class="layui-btn layui-btn-normal" value="确定" @click="confirm" />
					<input type="reset" class="layui-btn" value="重置" @click="reset" />
				</div>
			</div>
		</form>
		<div class="w-100">
			<div class="no-content">
				<img src="../../../static/img/no_data5.png">
			</div>
		</div>
		<table class="table table-hover w-100" v-if="false">
			<tr>
				<th width=""><label class="checkbox-inline"><input type="checkbox" class="checkbox-style allCheckbox"
							name="" id="" value="" />发票单号</label></th>
				<th width="">申请时间</th>
				<th width="">发票抬头</th>
				<th width="">发票性质</th>
				<th width="">发票总额</th>
				<th width="">发票状态</th>
				<th width="">操作</th>
			</tr>
			<tr>
				<td>
					<label class="checkbox-inline"><input type="checkbox" class="checkbox-style sonCheckbox" name=""
							id="" value="" />16161202</label>
				</td>
				<td>2020.05.31</td>
				<td>四川鑫润机械加工有限公司</td>
				<td>普通发票</td>
				<td>15000.00</td>
				<td>普通发票</td>
				<td><a href="" class="btns blue">查看</a></td>
			</tr>
			<tr>
				<td>
					<label class="checkbox-inline"><input type="checkbox" class="checkbox-style sonCheckbox" name=""
							id="" value="" />16161202</label>
				</td>
				<td>2020.05.31</td>
				<td>四川鑫润机械加工有限公司</td>
				<td>普通发票</td>
				<td>15000.00</td>
				<td>普通发票</td>
				<td><a href="" class="btns blue">查看</a></td>
			</tr>
		</table>
		<div class="user-info4 w-100 between-center" v-if="false">
			<div class="f-l between-center">
				<label class="checkbox-inline"><input type="checkbox" class="checkbox-style allCheckbox" name="" id=""
						value="" />&nbsp;</label>
				<span @click="checkboxItem">删除所选</span>
			</div>
			<div class="fanye gray">
				<div class="pull-right">
					<ul class="between-center">
						<li><a href="">&lt;</a></li>
						<li><a href="" class="active">1</a></li>
						<li><a href="">2</a></li>
						<li><a href="">3</a></li>
						<li><a href="">4</a></li>
						<li><a href="">5</a></li>
						<li><a href="">6</a></li>
						<li><a href="">&gt;</a></li>
					</ul>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import {
		message
	} from '@/common/common.js'
	export default {
		name: '',
		data() {
			return {

			}
		},
		mounted() {
			this.$emit('change_bread', 7);
		},
		methods: {
			checkboxItem() {
				$('.sonCheckbox:checkbox:checked').each(function() {
					console.log($(this).val())
				})
			},
			confirm() {
				message({
					message: '功能暂未开放',
					type: 'warning'
				})
			},
			reset() {
				message({
					message: '功能暂未开放',
					type: 'warning'
				})
			},
			pageJump(url) {
				message({
					message: '功能暂未开放',
					type: 'warning'
				})
			}
		}
	}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/pages/userCenter/invoiceManageList.vue